import { render, staticRenderFns } from "./FrzProcessAvailableKG.vue?vue&type=template&id=465f2f0c"
import script from "./FrzProcessAvailableKG.vue?vue&type=script&lang=js"
export * from "./FrzProcessAvailableKG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports